import queryString from 'query-string';
import { call, select } from 'redux-saga/effects';
import { ALLOWED_PROP_TYPES } from './constants';
import { getServerConfig } from './selectors';
import { API } from '../../../api';

export function* fetchWalkscore(address, lat, lng, config) {
  if (!address || !lat || !lng) return null;

  const props = config.report.sections.reduce((acc, section) => {
    if (!section && !section.properties) return acc;

    const columns = section.properties.filter(
      ({ type, endpoint, input }) => ALLOWED_PROP_TYPES.includes(type) &&
        endpoint === 'walkscore' &&
        input == null,
    );

    return acc.concat(columns);
  }, []);

  if (!props.length) return null;

  const serverConfig = yield select(getServerConfig);

  const path = `/walkscore/${serverConfig.namespace}?${queryString.stringify({
    address,
    lat,
    lng,
  })}`;

  const results = yield call(API, 'get', 'api', path);

  if (results.statusCode === 200) {
    return Object.entries(results).reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
  }

  return null;
}
